import Image from "next/image";
import { useAppSelector } from "../../../../../redux/hooks";
import { ConditionName, ISoundVolumeIconProps } from "../../../../../interfaces";
import { conditions } from "../../../../../helpers";
import IMAGES from "../../../../../images/importImages";
import { shallowEqual } from 'react-redux'

const SoundVolumeIcon = (props: ISoundVolumeIconProps) => {
    const { params, videoElementSizeInfo } = useAppSelector(({ videoData: { params, videoElementSizeInfo } }) => ({ params, videoElementSizeInfo }), shallowEqual);
    const { showMiniPlayer } = useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i 
                    className={`fa-solid ${conditions(ConditionName.hasSound) ? "fa-volume" : "fa-volume-xmark"} pl-text-white ${conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"} pl-cursor-pointer pl-flex pl-items-center ${conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[18px]"}`} 
                    {...props}
                />
            ) : (
                <Image
                    src={conditions(ConditionName.hasSound) ? IMAGES.unMute : IMAGES.mute}
                    alt={conditions(ConditionName.hasSound) ? "unmute-icon" : "mute-icon"}
                    className={`pl-flex pl-items-center pl-cursor-pointer`}
                    width={((params.portrait !== "true" || showMiniPlayer) && videoElementSizeInfo.width < 520) ? 14 : 22}
                    height={((params.portrait !== "true" || showMiniPlayer) && videoElementSizeInfo.width < 520) ? 13 : 22}
                    {...props}
                />
            )}
        </>

    )

}

export default SoundVolumeIcon;